import { AmplitudeEvents } from "../constants/amplitude";

import { setGroupProperty } from "./amplitude";

const RATE_PPM_PER_PERCENT = 10_000;

export type SalesTaxCreationSource = "form_editor" | "settings";

export const logSalesTaxCreated = ({
  logAmplitudeEvent,
  organizationId,
  source,
  ratePpm,
}: {
  logAmplitudeEvent: (event: AmplitudeEvents, payload?: Record<string, unknown>) => void;
  organizationId: string | undefined;
  source: SalesTaxCreationSource;
  ratePpm: number;
}): void => {
  logAmplitudeEvent(AmplitudeEvents.SalesTaxCreated, { source, tax_rate_percent: ratePpm / RATE_PPM_PER_PERCENT });
  if (organizationId) {
    setGroupProperty({ organizationId, property: "organization_uses_sales_tax", value: true });
  }
};
